import type {CreateExtArgs} from '@wix/document-manager-core'
import type {ComponentBeforeAddDataEvent} from '../hooks'

export const anchorBeforeAddHook = (createExtArgs: CreateExtArgs, data: ComponentBeforeAddDataEvent) => {
    data.componentDefinition.data.compId = data.compToAddPointer.id
}
